$(window).on('load', function() {
    $('#page-content').show();
});

// Escolha de unidade (mesmo e-mail em varias): Select2 com busca por parte do
// nome. O texto da <option> sai do PHP por htmlspecialchars e o Select2 o
// escapa de novo ao montar a lista (escapeMarkup padrao: nao sobrescrever).
$(function () {
    var $empresa = $('#select_empresa');
    if (!$empresa.length || typeof $.fn.select2 !== 'function') {
        return;
    }
    $empresa.select2({
        placeholder: 'Selecione ou digite o nome da unidade',
        width: '100%',
        language: {
            noResults: function () { return 'Nenhuma unidade encontrada'; }
        }
    });
});
